module.exports = __webpack_public_path__ + "img/upload.2f15ba3f.png";